import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import PrivateRoutes from 'utils/PrivateRoutes'
import SubscriptionPage from 'views/SubscriptionPage'
import EmailValidationSuccessPage from 'views/EmailValidationSuccessPage'
import PlansPage from 'views/offering/plan/PlansPage'
import DashboardPage from 'views/dashboard/DashboardPage'
import EmailValidationPage from 'views/EmailValidationPage'
import EmailValidationErrorPage from 'views/EmailValidationErrorPage'
import RecoveryErrorPage from 'views/RecoveryErrorPage'
import Company from 'views/Company'
import CollaboratorsPage from 'views/CollaboratorsPage'
import SubscriptionResume from 'views/SubscriptionResumen/SubscriptionResumen'
import SubscriptorSuccess from 'views/SubscriptorSuccess'
import OfferingPage from 'views/offering/OfferingPage'
import ErrorValidationAccountPage from 'views/ErrorValidationAccountPage'
import AccountsPage from 'views/offering/accounts/AccountsPage'
import AdditionalServicesPage from 'views/offering/additionalServices/AdditionalServicesPage'
import ResumePage from 'views/offering/resumePage/ResumePage'
import ErrorPage from 'views/offering/error/ErrorPage'
import ErrorPageRetry from 'views/offering/error/ErrorPageRetry'
import PublicRoutes from 'views/publicRoutes/PublicRoutes'
import LobbyWrapper from 'views/lobby/LobbyWrapper'

import SubscriptionData from 'components/subscription/subscriptionData'
import SubscriptionUser from 'components/subscription/subscriptionUser'
import SubscriptionPass from 'components/subscription/subscriptionPass'
import RecoveryUser from 'components/subscription/Recovery/RecoveryUser'
import RecoveryChangeUser from 'components/subscription/Recovery/RecoveryChangeUser'
import RecoveryChangePass from 'components/subscription/Recovery/RecoveryChangePass'
import RecoverySuccess from 'components/subscription/Success/RecoverySuccess'
import AccountSuccess from 'components/subscription/Success/AccountSuccess'
import ValidateIdentity from 'components/subscription/validate/ValidateIdentity'
import ValidateCollaborator from 'components/subscription/validate/ValidateCollaborator'
import AdministratorUser from 'components/subscription/administratorUser'
import ErrorSubscriptionPage from 'views/ErrorSubscriptionPage'
import SubscriptionResumenSuccess from 'views/SubscriptionResumen/SubscriptionResumenComponents/SubsiscriptionResumenExit/SuscriptionResumenExit'


export const Navigation = () => (
  <Router basename='onboarding2-ui'>
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path='lobby' element={<LobbyWrapper/>} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="empresa" element={<Company />} />
        <Route path="empresa/:id" element={<Company />} />
        <Route path="colaboradores" element={<CollaboratorsPage />} />
        <Route element={<OfferingPage />}>
          <Route path="planes" element={<PlansPage />} />
          <Route path="cuentas" element={<AccountsPage />} />
          <Route path="servicios-adicionales" element={<AdditionalServicesPage />} />
          <Route path="resumen" element={<ResumePage />} />
          <Route path="error" element={<ErrorPage />} />
        </Route>
      </Route>
      <Route element={<PublicRoutes />}>
        <Route path="suscripcion" element={<SubscriptionPage />}>
          <Route path="datos" element={<SubscriptionData />} />
          <Route path="usuario" element={<SubscriptionUser />} />
          <Route path="contrasena" element={<SubscriptionPass />} />
          <Route path="recuperar" element={<RecoveryUser />} />
          <Route path="recuperar-usuario" element={<RecoveryChangeUser />} />
          <Route path="recuperar-contrasena" element={<RecoveryChangePass />} />
          <Route path="error-recuperar" element={<RecoveryErrorPage />} />
          <Route path='exito' element={<RecoverySuccess />} />
          <Route path='correo' element={<EmailValidationPage />} />
          <Route path='error-correo' element={<EmailValidationErrorPage />} />
          <Route path='validacion-correo' element={<EmailValidationSuccessPage />} />
          <Route path='validacion-identidad' element={<ValidateIdentity />} />
          <Route path='crear-cuenta' element={<ValidateCollaborator />} />
          <Route path='error-crear-cuenta' element={<ErrorValidationAccountPage />} />
          <Route path='creacion-exitosa' element={<AccountSuccess />} />
          <Route path='exito' element={<SubscriptorSuccess />} />
          <Route path='crear-administrador' element={<AdministratorUser />} />
          <Route path='validacion-representante' element={<ValidateCollaborator />} />
          <Route path="error" element={<ErrorPage />} />
          <Route path="error-suscripcion" element={<ErrorSubscriptionPage />} />
        </Route>
        <Route path='resumen-suscripcion' element={<SubscriptionResume />} />
        <Route path='exito' element={<SubscriptionResumenSuccess />} />
        <Route path="error-reintentar" element={<ErrorPageRetry />} />
      </Route>
      <Route path="*" element={<>Not found</>} />
    </Routes>
  </Router>
)
